<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="frank-and-amy-194445">
<h1 style="margin-top: 200px; font-family: Arial;">Frank and Amy <br/>1944–45</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?70da6b41